import { SearchInput } from "@/ui/inputs/Input";
import { useEffect, useRef, useState } from "react";
import logoac from "../../../imagenes/lg_rentas_inomibialiras.png";
import useTable from "@/components/useTableServerSide";
import axios from "axios";
import { Dimmer } from "@/components/spinner";
import Footer from "@/components/Footer";
import { Mensaje } from "@/components/mensajes2";
import { RegistroContribuyenteEjido } from "./modalContribuyenteEjido";
import { Toasts } from "@/components/toasts";
import { RegistroResiduosSolidos } from "./modalContribuyenteResiduosSolidos.js";

export default function TablaContribuyenteEjidos() {
  const op = require("../../../../src/modulos/datos");
  const token = localStorage.getItem("jwtToken");
  const factorCambio = JSON.parse(localStorage.getItem("factorCambio"));
  const permiso = JSON.parse(localStorage.getItem("accrenta"));

  // Estados para búsqueda y tabla
  const [searchInput, setSearchInput] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const [records, setRecords] = useState([]);
  const [comercio, setComercio] = useState();
  const [loading, setLoading] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [totales, setTotales] = useState({
    total: 0,
    activos: 0,
    inactivos: 0,
  });
  const [tableState, setTableState] = useState({
    page: 0,
    rowsPerPage: 10,
    search: "",
  });
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });
  const searchTimeoutRef = useRef(null);

  // Estados para el modal
  const [showModal, setShowModal] = useState(false);
  const [operacion, setOperacion] = useState(0); // 4=consultar, 2=editar, 3=eliminar
  const [inmobiliaria, setInmobiliaria] = useState(null);
  const [inmueble, setInmueble] = useState(null);
  const [deuda, setDeuda] = useState([]);
  const [historico, setHistorico] = useState([]);
  const [credito, setCredito] = useState(0);
  const [rentas, setRentas] = useState([]);
  const [clasificador, setClasificador] = useState([]);
  const [confiRenta, setConfiRenta] = useState(null);
  const [periodoR, setPeriodoR] = useState(12);
  const [periodoPagoR, setPeriodoPagoR] = useState(1);
  const [valorUT, setValorUT] = useState(0);
  const [valorPorce, setValorPorce] = useState(100.0);
  const [declaWeb, setDeclaWeb] = useState(false);

  // Definición de columnas de la tabla
  const headCells = [
    {
      id: "idrentas",
      label: "CODIGO",
      width: "200px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "cedrif",
      label: "CEDULA/RIF",
      width: "200px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "nombrearrendatario",
      label: "NOMBRE ARRENDATARIO",
      width: "300px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "descripcion",
      label: "RENTA",
      width: "200px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "opciones",
      label: "OPCIONES",
      width: "60px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
  ];

  // Datos para tarjetas
  const cardsData = [
    {
      title: "Rentas Inmobiliarias Registrados",
      value: totales.total || 0,
      color: "#053160",
      icon: "fas fa-cash-register fa-3x",
      iconColor: "rgba(255,255,255,0.2)",
      print: () => imprimirReporte(" RENTA.status in(1,0) "),
    },
    {
      title: "Rentas Inmobiliarias Activos",
      value: totales.activos || 0,
      color: "#76b8e8",
      icon: "fas fa-toggle-on fa-3x",
      iconColor: "rgba(255,255,255,0.2)",
      print: () => imprimirReporte(" RENTA.status = 0 "),
    },
    {
      title: "Rentas Inmobiliarias Inactivos",
      value: totales.inactivos || 0,
      color: "#ca4117",
      icon: "fas fa-toggle-off fa-3x",
      iconColor: "rgba(255,255,255,0.2)",
      print: () => imprimirReporte(" RENTA.status =1 "),
    },
  ];

  // Callbacks para la paginación de la tabla
  const tableCallbacks = {
    onPageChange: (newPage) =>
      setTableState((prev) => ({ ...prev, page: newPage })),
    onRowsPerPageChange: (newLimit) =>
      setTableState((prev) => ({ ...prev, rowsPerPage: newLimit, page: 0 })),
  };

  const { TblContainer, TblHead, TblPagination } = useTable(
    totalRecords,
    headCells,
    false,
    tableCallbacks,
  );

  // Manejo de búsqueda con debounce
  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchInput(value);
    if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
    if (value.length === 0)
      return setTableState((prev) => ({ ...prev, search: "", page: 0 }));
    if (value.length < 3) return;
    searchTimeoutRef.current = setTimeout(
      () => setTableState((prev) => ({ ...prev, search: value, page: 0 })),
      500,
    );
  };

  // Obtener registros de la tabla (paginados y con búsqueda)
  const buscarRentasInmobiliarias = () => {
    setLoading(true);
    const params = {
      page: tableState.page,
      limit: tableState.rowsPerPage,
      search: tableState.search,
    };
    const endpoint = `${op.conexion}/api/aseo/gestion-contribuyentes`;
    const controller = new AbortController();
    axios
      .get(endpoint, {
        params,
        signal: controller.signal,
        headers: {
          "x-access-token": token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data) {
          setRecords(response.data.rows);
          setTotalRecords(response.data.count);
          setTotales(response.data.totales);
        }
      })
      .catch((error) => {
        if (axios.isCancel(error)) return;
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto:
            error.response?.data?.message ||
            "Error al conectar con el servidor",
          icono: "error",
        });
      })
      .finally(() => setLoading(false));
  };

  // Imprimir reporte
  const imprimirReporte = (sql) => {
    try {
      window.open(
        op.reportes +
          "/rentasinmobiliarias?" +
          "reporte=ListRentasContrib" +
          "&sql= " +
          sql +
          " " +
          "&sql2= and ",
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto: "Error al Imprimir el Reporte",
        icono: "error",
      });
    }
  };

  // Carga la configuración necesaria para el modal (solo se ejecuta al abrirlo)
  const cargarDatosParaModal = () => {
    setLoading(true);
    const peticiones = [
      // Valor UT / petro
      axios.get(`${op.conexion}/api/efiscal/valorpetro`, {
        headers: { "x-access-token": token },
      }),
      // Configuración de rentas
      axios.get(
        `${op.conexion}/api/comun/seleccionaregistros?campos=*&nomtab=configrentas&orden=1`,
        { headers: { "x-access-token": token } },
      ),
      // Tipos de renta
      axios.get(
        `${op.conexion}/api/consulta/selecionarregistrocondi?campos=*&nomtab=tiporentas&condi=1=1&orden=idtiporentas`,
        { headers: { "x-access-token": token } },
      ),
      // Clasificador
      axios.get(
        `${op.conexion}/api/consulta/selecionarregistrocondi?campos=*&nomtab=claseaseo&condi=actualizada = true and tipo = 1&orden=idclaseaseo`,
        { headers: { "x-access-token": token } },
      ),
    ];

    return Promise.all(peticiones)
      .then(([resValorUT, resConfig, resTipos, resClasif]) => {
        // Valor UT
        setValorUT(resValorUT.data.valor);

        // Configuración de rentas
        if (resConfig.data && resConfig.data.length > 0) {
          const config = resConfig.data[0];
          setConfiRenta(config);
          setDeclaWeb(config.declaracionweb);
          switch (parseInt(config.periodopago)) {
            case 1:
              setPeriodoR(12);
              setPeriodoPagoR(1);
              break;
            case 2:
              setPeriodoR(4);
              setPeriodoPagoR(3);
              break;
            case 3:
              setPeriodoR(1);
              setPeriodoPagoR(1);
              break;
            default:
              break;
          }
          setValorPorce(config.valorporcentual == 1 ? 100.0 : 1000.0);
        }

        // Tipos de renta
        setRentas(resTipos.data || []);

        // Clasificador
        setClasificador(resClasif.data || []);
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: "Error al cargar configuración para el modal",
          icono: "error",
        });
        throw error;
      })
      .finally(() => setLoading(false));
  };
  const seleccionarRegistroComercio = (data) => {
    let campos = "*";
    let nomtab = "comercio";
    let nomid = "idcomercio";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${data}&nomtab=${nomtab}&nomid=${nomid}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idcomercio > 0) {
            setComercio(response.data);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };
  // Consulta un registro específico y sus datos asociados
  const seleccionarRegistro = (idrentas) => {
    setLoading(true);
    const campos = "*";
    const nomtab = "rentasinmobiliarias";
    const nomid = "idrentas";
    const endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idrentas}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (
          response.status === 200 &&
          response.data &&
          response.data.idrentas
        ) {
          setInmobiliaria(response.data);
          if (response.data.idinmueble > 0) {
            seleccionarRegistroInmueble(response.data);
          } else {
            setInmueble(null);
            setDeuda([]);
            setHistorico([]);
            setCredito(0);
            setLoading(false);
            setShowModal(true); // Ya la operación se estableció antes
          }
        } else {
          throw new Error("No se encontró el registro");
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response?.data?.message || error.message,
          icono: "error",
        });
        setLoading(false);
      });
  };

  const seleccionarRegistroInmueble = (renta) => {
    const campos = "*";
    const nomtab = "inmueble";
    const nomid = "idinmueble";
    const endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${renta.idinmueble}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (
          response.status === 200 &&
          response.data &&
          response.data.idinmueble
        ) {
          setInmueble(response.data);
          setCredito(response.data.credito || 0);
          SelectDeudaC(renta);
        } else {
          setInmueble(null);
          setDeuda([]);
          setHistorico([]);
          setLoading(false);
          setShowModal(true);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response?.data?.message || error.message,
          icono: "error",
        });
        setLoading(false);
      });
  };

  const SelectDeudaC = (renta) => {
    const tabla = "aseo";
    const fechaSistema = localStorage.getItem("fechasistema");
    const espiritu = JSON.parse(localStorage.getItem("espiritu"));
    let endpoint =
      espiritu === 0
        ? `${op.conexion}/api/aseo/deudarenta?idrentas=${renta.idrentas}&fecha=${fechaSistema}&tabla=${tabla}`
        : `${op.conexion}/api/aseo/deudarenta1?idrentas=${renta.idrentas}&fecha=${fechaSistema}&tabla=${tabla}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        if (response.status === 200) {
          const deu = [];
          const his = [];
          response.data.forEach((item) => {
            if (item.fechapago === null) {
              deu.push({
                anio: item.anio,
                mes: item.mes?.replace(/'/g, ""),
                monto: item.mondeu,
                intereses: item.intmoradeu,
                multa: item.multa,
                recargo: item.recargodeu,
              });
            } else {
              his.push({
                anio: item.anio,
                mes: item.mes?.replace(/'/g, ""),
                monto: item.mondeu,
                intereses: item.intmoradeu,
                recargo: item.recargodeu,
                multa: item.multa,
                descuento: item.mondescue,
                recibo: item.numreci,
                fechapago: item.fechapago,
              });
            }
          });
          setDeuda(deu);
          setHistorico(his);
        }
        setLoading(false);
        setShowModal(true); // Ya la operación se estableció antes
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: error.response?.data?.message || error.message,
          icono: "error",
        });
        setLoading(false);
      });
  };

  // Maneja el clic en Ver, Editar o Eliminar
  const handleAccion = async (id, operacion) => {
    let permisoRequerido;
    let textoAlerta;

    switch (operacion) {
      case 4: // Consultar
        permisoRequerido = permiso?.toString().substring(0, 1) === "1";
        textoAlerta = "No posee permiso para Consultar";
        break;
      case 2: // Editar
        permisoRequerido = permiso?.toString().substring(2, 3) === "1";
        textoAlerta = "No posee permiso para Editar";
        break;
      case 3: // Eliminar
        permisoRequerido = permiso?.toString().substring(3, 4) === "1";
        textoAlerta = "No posee permiso para Eliminar";
        break;
      default:
        return;
    }

    if (!permisoRequerido) {
      setToast({
        mostrar: true,
        mensaje: textoAlerta,
        titulo: "Alerta.",
      });
      return;
    }

    try {
      // Si aún no se ha cargado la configuración para el modal, se carga
      if (!confiRenta || rentas.length === 0 || clasificador.length === 0) {
        await cargarDatosParaModal();
      }
      // Establecer la operación y consultar el registro
      setOperacion(operacion);
      seleccionarRegistro(id);
      seleccionarRegistroComercio(id);
    } catch (error) {
      // El error ya fue manejado en cargarDatosParaModal
      console.error("Error en handleAccion:", error);
    }
  };

  // Refrescar tabla cuando cambia paginación o búsqueda
  useEffect(() => {
    buscarRentasInmobiliarias();
  }, [tableState]);

  return (
    <div
      className="container-fluid p-4"
      style={{ backgroundColor: "#f8f9fa", height: "90vh", marginTop: "-5%" }}
    >
      {/* Tarjetas superiores */}
      <div className="row g-4 mb-4">
        {cardsData.map((card, index) => (
          <div
            key={index}
            style={{ borderRadius: 4 }}
            className="col-12 col-sm-6 col-xl"
          >
            <div
              className="card h-100 border-0 rounded-4 shadow-sm position-relative overflow-hidden"
              style={{
                background: card.color,
                color: "white",
                transition: "transform 0.3s, box-shadow 0.3s",
                borderRadius: 15,
                cursor: "pointer",
                boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-5px)";
                e.currentTarget.style.boxShadow = "0 15px 40px rgba(0,0,0,0.2)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 10px 30px rgba(0,0,0,0.1)";
              }}
            >
              {/* Círculo decorativo */}
              <div
                style={{
                  position: "absolute",
                  top: -20,
                  right: -20,
                  width: 100,
                  height: 100,
                  borderRadius: "50%",
                  background: "rgba(255, 255, 255, 0.1)",
                }}
              ></div>
              <div
                style={{
                  position: "absolute",
                  bottom: -30,
                  left: -30,
                  width: 150,
                  height: 150,
                  borderRadius: "50%",
                  background: "rgba(255, 255, 255, 0.05)",
                }}
              ></div>

              <div className="card-body p-3">
                <div className="d-flex justify-content-between align-items-start">
                  <div>
                    <span
                      className="text-uppercase small fw-bold opacity-75"
                      style={{ letterSpacing: "2px", fontSize: "1rem" }}
                    >
                      {card.title}
                    </span>
                    <h2
                      className="fw-bold mb-0 mt-1"
                      style={{ fontSize: "2.2rem" }}
                    >
                      {card.value}
                    </h2>
                  </div>
                  <i
                    className={card.icon}
                    style={{ color: card.iconColor }}
                  ></i>
                </div>
                {card.print && (
                  <div
                    className="mt-2"
                    style={{ position: "relative", zIndex: 10 }}
                  >
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        card.print();
                      }}
                      className="btn btn-sm btn-light rounded-circle p-2"
                      style={{
                        width: "35px",
                        height: "35px",
                        cursor: "pointer",
                        position: "relative",
                        zIndex: 20,
                      }}
                    >
                      <i className="fas fa-print"></i>
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Tabla principal */}
      <div className="row g-4">
        <div className="col-8">
          <div
            className="card shadow-sm border-0"
            style={{ borderRadius: "15px" }}
          >
            <div className="card-header azulGradiant text-white">
              <h5 className="mb-0 fw-bold">
                Gestión de Contribuyentes Rentas Inmobiliarias
              </h5>
            </div>
            <div className="card-body p-0 m-0">
              <div className="col-12 m-0 my-2 p-0 d-flex justify-content-between align-items-start">
                <div className="col-4 m-0 p-0 position-relative">
                  <SearchInput
                    className="search-input pe-4"
                    value={searchInput}
                    onChange={handleSearch}
                  />
                </div>
              </div>
              <section className="col-12 m-0 p-0">
                <TblContainer>
                  <TblHead />
                  <tbody>
                    {records &&
                      records.map((item, index) => (
                        <tr
                          key={index}
                          style={{ padding: "0", cursor: "pointer" }}
                        >
                          <td
                            className="align-baseline"
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                              width: "10px",
                            }}
                          >
                            {item.idrentas}
                          </td>
                          <td
                            className="align-baseline"
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                              width: "100px",
                            }}
                          >
                            {item.cedrif}
                          </td>
                          <td
                            className="align-baseline"
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                              width: "auto",
                            }}
                          >
                            {item.nombrearrendatario}
                          </td>
                          <td
                            className="align-baseline"
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                              width: "auto",
                            }}
                          >
                            {item.descripcion}
                          </td>
                          <td
                            className="py-1"
                            style={{
                              fontSize: "10px",
                              textAlign: "center",
                              width: "180px",
                              padding: 0,
                            }}
                          >
                            <button
                              onClick={() => handleAccion(item.idrentas, 4)}
                              className={
                                permiso.toString().substring(0, 1) === "1"
                                  ? "btn btn-sm btn-info rounded-circle"
                                  : "btn btn-sm btn-secondary rounded-circle"
                              }
                            >
                              <i className="fas fa-eye"></i>
                            </button>
                            <button
                              onClick={() => handleAccion(item.idrentas, 2)}
                              className={
                                permiso.toString().substring(2, 3) === "1"
                                  ? "btn btn-sm btn-warning rounded-circle mx-3"
                                  : "btn btn-sm btn-secondary rounded-circle mx-3"
                              }
                            >
                              <i className="fa fa-edit"></i>
                            </button>
                            <button
                              onClick={() => handleAccion(item.idrentas, 3)}
                              className={
                                permiso.toString().substring(3, 4) === "1"
                                  ? "btn btn-sm btn-danger rounded-circle"
                                  : "btn btn-sm btn-secondary rounded-circle"
                              }
                            >
                              <i className="fa fa-trash-alt"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </TblContainer>
                <TblPagination />
              </section>
            </div>
          </div>
        </div>

        {/* Imagen lateral */}
        <div className="col-md-4">
          <div
            className="card shadow-1-strong d-flex align-items-center justify-content-center"
            style={{ borderRadius: "15px", minHeight: "500px" }}
          >
            <div className="text-center p-4">
              <img
                src={logoac}
                alt="Dashboard Illustration"
                className="img-fluid"
                style={{
                  maxHeight: "500px",
                  maxWidth: "100%",
                  objectFit: "contain",
                }}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Modal de registro */}
      {/* <RegistroContribuyenteEjido
        factorCambio={factorCambio?.valor}
        show={showModal}
        onHideCancela={() => setShowModal(false)}
        inmobiliaria={inmobiliaria}
        rentas={rentas}
        operacion={operacion}
        onHideRenderizar={buscarRentasInmobiliarias}
        onHideRenderizar2={SelectDeudaC}
        clasificador={clasificador}
        inmueble={inmueble}
        confiRenta={confiRenta}
        periodoPagoR={periodoPagoR}
        periodoR={periodoR}
        valorUT={valorUT}
        valorPorce={valorPorce}
        declaWeb={declaWeb}
        deuda={deuda}
        historico={historico}
        credito={credito}
      /> */}
      <RegistroResiduosSolidos
        factorCambio={factorCambio}
        show={showModal}
        onHideCancela={() => setShowModal(false)}
        inmobiliaria={inmobiliaria}
        rentas={rentas}
        operacion={operacion}
        onHideRenderizar={buscarRentasInmobiliarias}
        onHideRenderizar2={SelectDeudaC}
        clasificador={clasificador}
        inmueble={inmueble}
        comercio={comercio}
        confiRenta={confiRenta}
        periodoPagoR={periodoPagoR}
        periodoR={periodoR}
        valorUT={valorUT}
        valorPorce={valorPorce}
        declaWeb={declaWeb}
        deuda={deuda}
        historico={historico}
        credito={credito}
        tipoContribuyente={1}
        actividad={''}
      />
      {/* Mensaje de error/aviso */}
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />

      {/* Indicador de carga */}
      <Dimmer active={loading} inverted />
      <Toasts
        show={toast.mostrar}
        titulo={toast.titulo}
        mensaje={toast.mensaje}
        onHideCancela={() =>
          setToast({
            ...toast,
            mostrar: false,
          })
        }
      />
      {/* Footer */}
      <Footer />
    </div>
  );
}
